import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export const useCategories = () => {
  const [cats, setCats] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    api.get("/categories").then((r) => { cache = r.data; setCats(r.data); });
  }, []);
  return cats;
};
